import React from 'react'
import { getDateFromTimestamp } from 'src/utils/date'
import { getQueryParams } from 'src/utils/getQueryParams'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from '@hooks/useClinic'
import { useIsTreatmentCancellable } from '@screens/OnlineCancellation/helpers/useIsTreatmentCancellable'
import { OnlineCancellationScreen } from '@screens/OnlineCancellation/OnlineCancellation'

export const OnlineCancellation = () => {
  const { appointmentDate, appointmentBundleReferenceId } = getQueryParams()
  const date = getDateFromTimestamp(appointmentDate as string)
  const { clinicId } = useConfig()
  const { data: clinic } = useClinic(clinicId)
  const { data: isTreatmentCancellable, isLoading } = useIsTreatmentCancellable(appointmentBundleReferenceId as string)

  return (
    <OnlineCancellationScreen
      appointmentBundleReferenceId={(appointmentBundleReferenceId as string) || ''}
      date={date}
      clinic={clinic}
      isTreatmentCancellable={isTreatmentCancellable}
      loading={isLoading}
    />
  )
}
